import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpRequest, HttpParams, HttpHeaders, HttpEvent } from '@angular/common/http';
import { AuthenticationService } from '../auth';
import { Globals } from '../globals';
import { Cookie } from 'ng2-cookies';
import { Observable } from 'rxjs';

@Injectable()
export class ExportImportService implements OnInit {

    constructor(private http: HttpClient, private authService: AuthenticationService, private globals: Globals) { }

    ngOnInit() : void {
        this.authService.isTokenValid();
    }

    /**
     * Upload file
     * @param file
     */
    pushFileToStorage(file: File) : Observable<HttpEvent<{}>> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/import/';
        let requestHeaders = new HttpHeaders()
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());
        let formdata: FormData = new FormData();
        formdata.append('file', file);

        const req = new HttpRequest('POST', url, formdata, {
          headers: requestHeaders,
          reportProgress: true,
          responseType: 'text'
        });

        return this.http.request(req);
    }

    deleteFile(file: File) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/import/file/' + file.name;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.delete(url, {headers: requestHeaders, responseType: 'text'})
    }

    /**
     * Retrieves data about the employer specified by its uuid
     * @param file
     */
    getXml(file: File) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/import/file/' + file.name;
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        return this.http.get(url, {headers: requestHeaders, responseType: 'json'})
    }

    updateEntities(entities) : Observable<any> {
        this.authService.isTokenValid();
        const url = this.authService.getResourceURL() + '/api/v1/import/update';
        let requestHeaders = new HttpHeaders()
            .set('Content-Type', 'application/x-www-form-urlencoded; charset=utf-8')
            .set('Authorization', 'Bearer ' + this.authService.getAccessToken());

        const body = new HttpParams()
            .set('entityBody', JSON.stringify(entities));

        return this.http.post(url, body, {headers: requestHeaders, responseType: 'json'});
    }
}
